<div @fade class="settings-container">
  <div class="center-container">
    <div class="title">
      Ajustes del Perfíl
    </div>
    <div class="container-form">
      <form autocomplete="off" method="POST" [formGroup]="settings">
        <div class="fieldset-container">
          <p class="title-form first-cihld">Datos personales</p>
          <div class="input-control-error">
            <input type="text" formControlName="name"
              [ngClass]="{'error-input': !settings.controls.name.value && settings.controls.name.touched }" id="nameId"
              class="input-search" name="" placeholder="Nombre">
          </div>
          <div class="input-control-error container-surname">
            <input type="text" formControlName="surname"
              [ngClass]="{'error-input': !settings.controls.surname.value && settings.controls.surname.touched }"
              id="surnameId" class="input-search special-width" name="" placeholder="Primer Apellido">
            <input type="text" formControlName="surnameTwo"
              [ngClass]="{'error-input': !settings.controls.surnameTwo.value && settings.controls.surnameTwo.touched }"
              id="surname2Id" class="input-search special-width" name="" placeholder="Segundo Apellido">
          </div>
          <div class="input-control-error phone">
            <input type="text" formControlName="phone" maxlength="9"
              [ngClass]="{'error-input': settings.controls.phone.invalid && settings.controls.phone.dirty }"
              id="phoneNumber" class="input-search" name="" placeholder="Número de teléfono">
            <div class="div-error" *ngIf="settings.controls.phone.invalid && settings.controls.phone.dirty"
              [innerHTML]="'PROFILE.ERRORS.PHONE' | translate">
            </div>
          </div>
          <div class="input-control-error">
            <input type="text" formControlName="email" id="emailId" class="input-search email-color-background" placeholder="Email" name="">
          </div>
        </div>
        <div class="fieldset-container">
          <div class="title-form">
            Consentimientos comerciales
          </div>
          <div class="container-checkbox">
            <mat-checkbox formControlName="ofers" id="termsId" aria-label="checkbox">
            </mat-checkbox>
            <p>
              Deseo recibir emails con novedades, información comercial y avisos de la aplicación
            </p>
          </div>
          <div class="button-container">
            <button class="save" *ngIf="showProgress" id="saveData"
              [ngClass]="{ 'ready': settings.valid && settings.dirty}" [disabled]="settings.invalid"
              (click)="saveInformation()">Guardar cambios</button>
            <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="!showProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
        </div>
      </form>

      <form *ngIf="showChangePass" method="POST" autocomplete="off" [formGroup]="passForm">
        <div class="fieldset-container pass-container">
          <div class="title-form">
            Cambio de contraseña
          </div>
          <div class="input-control-error">
            <div class="see-pass">
              <input type="{{type}}" id="currentPasswordId" formControlName="currentPassword" class="input-search"
                name="" placeholder="Contraseña actual">
              <img src="./assets/signin/see_pass.svg" *ngIf="passForm.controls.currentPassword.value"
                (mousedown)="showPass(1)" (mouseup)="showPass(2)" alt="">
            </div>
            <div class="div-error"
              *ngIf="!passForm.controls.currentPassword.valid && passForm.controls.currentPassword.touched"
              [innerHTML]="'PROFILE.ERRORS.ALL_VALIDATIONS' | translate">
            </div>
          </div>
          <div class="input-control-error">
            <div class="see-pass">
              <input type="{{newType}}" id="passwordId" formControlName="password" class="input-search" name=""
                placeholder="Nueva contraseña">
              <img src="./assets/signin/see_pass.svg" *ngIf="passForm.controls.currentPassword.value"
                (mousedown)="showNewPass(1)" (mouseup)="showNewPass(2)" alt="">
            </div>
            <div class="div-error" *ngIf="passForm.controls.password.value && passForm.controls.currentPassword.value &&
            passForm.controls.password.value === passForm.controls.currentPassword.value &&
            passForm.controls.password.touched" [innerHTML]=" 'PROFILE.ERRORS.EQUALS' | translate">
            </div>
            <div class="div-error"
              *ngIf="!passForm.controls.password.value && passForm.controls.password.touched && passForm.controls.password.invalid"
              [innerHTML]="'PROFILE.ERRORS.ALL_VALIDATIONS' | translate">
            </div>
          </div>
          <div class="input-control-error last-input">
            <input type="password" id="passwordTwoId" formControlName="passwordTwo" class="input-search" name=""
              placeholder="Repetir contraseña">
            <div class="div-error"
              *ngIf="passForm.controls.passwordTwo.value && passForm.controls.passwordTwo.touched && squals"
              [innerHTML]=" 'PROFILE.ERRORS.PASSWORD_2_REQUIRED' | translate">
            </div>
          </div>
          <br>
          <div class="save-container">
            <button class="save" *ngIf="showPassProgress" id="saveDataPass" [ngClass]="{ 'ready': passForm.valid }"
              (click)="savePass()">Cambiar contraseña</button>
            <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="!showPassProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
          <div (click)="deleteAccount()" class="delete-account">
            ¿Quieres eliminar tu cuenta? Haz click aquí
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<app-loading-akana *ngIf="showLoading"></app-loading-akana>
